/**
 * theme.js — Main theme JavaScript
 * Handles collection filter sidebar, contact form, and fly-to-cart animation.
 * Mobile menu and mini-cart are handled by header.liquid inline script.
 * Scroll detection is handled by header.liquid inline script.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    /* ------------------------------------------------------------------ */
    /*  Collection filter sidebar (mobile)                                */
    /* ------------------------------------------------------------------ */
    var filterToggle = document.querySelector('[data-action="toggle-filters"]');
    var filterSidebar = document.querySelector('#collection-filters');
    var filterOverlay = document.querySelector('.collection-overlay');

    function openFilters() {
      if (filterSidebar) filterSidebar.classList.add('mobile-open');
      if (filterOverlay) filterOverlay.classList.add('is-visible');
      if (filterToggle) filterToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeFilters() {
      if (filterSidebar) filterSidebar.classList.remove('mobile-open');
      if (filterOverlay) filterOverlay.classList.remove('is-visible');
      if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (filterToggle) {
      filterToggle.addEventListener('click', function () {
        var isOpen = filterSidebar && filterSidebar.classList.contains('mobile-open');
        if (isOpen) { closeFilters(); } else { openFilters(); }
      });
    }

    if (filterOverlay) {
      filterOverlay.addEventListener('click', closeFilters);
    }

    var filterCloseBtn = filterSidebar ? filterSidebar.querySelector('[data-action="close-filters"]') : null;
    if (filterCloseBtn) {
      filterCloseBtn.addEventListener('click', closeFilters);
    }

    /* ------------------------------------------------------------------ */
    /*  Contact form AJAX submit                                           */
    /* ------------------------------------------------------------------ */
    var contactForm = document.querySelector('#contact_form');
    var contactSuccess = document.querySelector('.contact-success');

    if (contactForm) {
      contactForm.addEventListener('submit', function (e) {
        e.preventDefault();

        var formData = new FormData(contactForm);
        var submitBtn = contactForm.querySelector('button[type="submit"]');
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending...'; }

        fetch('/contact#contact_form', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' }
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Submission failed');
            return res.json();
          })
          .then(function () {
            contactForm.style.display = 'none';
            if (contactSuccess) contactSuccess.style.display = 'block';
          })
          .catch(function () {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Send Message'; }
            var errMsg = contactForm.querySelector('.contact-error');
            if (!errMsg) {
              errMsg = document.createElement('p');
              errMsg.className = 'contact-error';
              errMsg.style.cssText = 'color:#c0392b;margin-top:0.75rem;font-size:0.875rem;';
              errMsg.textContent = 'Something went wrong. Please try again.';
              contactForm.appendChild(errMsg);
            }
          });
      });
    }

    /* ------------------------------------------------------------------ */
    /*  Fly-to-cart animation                                               */
    /* ------------------------------------------------------------------ */
    document.addEventListener('kaqaz:fly-to-cart', function (e) {
      var detail = e.detail || {};
      var startX = detail.x || 0;
      var startY = detail.y || 0;
      var imageUrl = detail.image || '';

      var cartIcon = document.querySelector('#cartTrigger');
      if (!cartIcon) return;

      var cartRect = cartIcon.getBoundingClientRect();
      var endX = cartRect.left + cartRect.width / 2;
      var endY = cartRect.top + cartRect.height / 2;

      var flyer = document.createElement('div');
      flyer.className = 'fly-to-cart-item';
      flyer.style.cssText = [
        'position:fixed',
        'z-index:99999',
        'pointer-events:none',
        'width:50px',
        'height:50px',
        'border-radius:50%',
        'overflow:hidden',
        'box-shadow:0 4px 12px rgba(0,0,0,0.25)',
        'transition:all 600ms cubic-bezier(0.2,0.8,0.2,1)',
        'top:' + startY + 'px',
        'left:' + startX + 'px',
        'opacity:1',
        'transform:scale(1)'
      ].join(';');

      if (imageUrl) {
        var img = document.createElement('img');
        img.src = imageUrl;
        img.alt = '';
        img.style.cssText = 'width:100%;height:100%;object-fit:cover;';
        flyer.appendChild(img);
      }

      document.body.appendChild(flyer);

      flyer.offsetHeight;
      flyer.style.top  = endY + 'px';
      flyer.style.left = endX + 'px';
      flyer.style.transform = 'scale(0.2)';
      flyer.style.opacity = '0';

      setTimeout(function () {
        flyer.remove();
        cartIcon.classList.add('cart-bounce');
        setTimeout(function () {
          cartIcon.classList.remove('cart-bounce');
        }, 600);
      }, 650);
    });

  });
})();
